import { DFVE, DocumentoRigaCreateMultiParams } from '../../../../../models';
import { AxiosResponse } from 'axios';
import {
  handleError,
  URL_GESTIFY_DOCUMENTI_RIGHE,
  URL_RIGHE,
} from '../../../../../utils';
import { apiClient } from '../../../../../helpers';
import { getGestifyTokenCookies } from '../../../../../helpers/authCookies';

export const gestifyCreateMultiDfveRiga = async ({
  parentId,
  documento_righe,
}: DocumentoRigaCreateMultiParams) => {
  try {
    console.log({ documento_righe });
    const token = getGestifyTokenCookies().gestifyToken;
    const response = await apiClient.post<AxiosResponse>({
      url: `${URL_GESTIFY_DOCUMENTI_RIGHE}/${DFVE}/${parentId}${URL_RIGHE}`,
      params: { documento_righe, token },
    });
    console.log('gestifyCreateMultiDfveRiga', response);
    if (response.status >= 200 || response.status < 300) {
      return { data: response.data };
    }

    return handleError(response.status, response.data?.status);
  } catch (error: any) {
    return handleError(
      error?.response?.status ?? error?.message,
      error?.response?.data,
    );
  }
};
